export default [
  { questionType: 'Textbox', languageKey: 'textBox', icon: 'text_fields' },
  { questionType: 'Textarea', languageKey: 'textArea', icon: 'subject' },
  { questionType: 'NumberInput', languageKey: 'numberInput', icon: 'money' },
  {
    questionType: 'Dropdown',
    languageKey: 'dropDown',
    icon: 'arrow_drop_down_circle',
    outlined: true,
  },
  { questionType: 'Checkbox', languageKey: 'checkBox', icon: 'check_box' },
  { questionType: 'Date', languageKey: 'date', icon: 'event' },
  { questionType: 'Time', languageKey: 'time', icon: 'schedule' },
  { questionType: 'DateTime', languageKey: 'dateAndTime', icon: 'date_range' },
  { questionType: 'SingleSelection', languageKey: 'singleSelection', icon: 'format_list_bulleted' },
  {
    questionType: 'MultipleSelection',
    languageKey: 'multiSelection',
    icon: 'ballot',
    outlined: true,
  },
  { questionType: 'Hyperlink', languageKey: 'hyperlink', icon: 'link' },
  { questionType: 'Paragraph', languageKey: 'paragraph', icon: 'code' },
]
